import { isNullOrUndefined } from "../../../../../../../tools";
import { IdProvider } from "../../../../../../services/idprovider.service";
import { ServerCommunicatorService } from "../../../../../../services/server-communicator.service";
import { UIUtils } from "../../../../../../services/uiutils.service";
import { Utils } from "../../../../../../services/utils.service";
import { DataContainer } from "../../../../../infrastructure/datacontainer";
import { DataContainerService } from "../../../../../infrastructure/datacontainer.service";
import { RequestTypes } from "../../../../../infrastructure/enums";
import { IPersistable } from "../../../../../infrastructure/IPersistable";
import { PayloadPacketFacade } from "../../../../../infrastructure/payloadpacket/payloadpacketfacade";
import { TransportData } from "../../../../../infrastructure/transportdata";
import { ValidationResultAccumulator } from "../../../../../infrastructure/validationresultaccumulator";
import { ValidationMessages, ValidationPatterns } from "../../../../constants";
import { SCFetchRequest } from "./scfetchrequest";

export class SCProps {

public created_date: string = '';
  public updated_date: string = '';
  public created_by: number = 0;
  public updated_by: number = 0;

  public id: number = 0;
  public name: string = '';
  public name_mr: string = '';
  public month: string = '';
  public state_id: number = 0;
  public readonly state_name_en: string = '';
  public readonly state_name_mr: string = '';
  public zone_id: number = 0;
  public readonly zone_name: string = '';
  public district_id: number = 0;
  public readonly district_name_en: string = '';
  public readonly district_name_mr: string = '';
  public block_id: number = 0;
  public bcm_post_id: number = 0;
  public readonly block_name_en: string = '';
  public readonly block_name_mr: string = '';
  public phc_id: number = 0;
  public readonly phc_name: string = '';
  
  public sanctioned_no_of_asha_in_sc: number = 0;

  public financial_year_id: number = 0;
  
  public readonly is_newly_created: boolean = false;

  private constructor(IsNewlyCreated: boolean) {
    this.is_newly_created = IsNewlyCreated;
  }

  public static Blank() {
    return new SCProps(true);
  }
}

export class SC implements IPersistable<SC> {
  public static readonly mastertablename: string = 'sc_master';

  private constructor(public readonly p: SCProps, public readonly AllowEdit: boolean) {

  }

  public async EnsurePrimaryKeysWithValidValues(): Promise<void> {
    if (this.p.id === undefined || this.p.id === 0) {
      const newids = await IdProvider.GetInstance().GetNextEntityId();
      // const newids = await IdProvider.GetInstance().GetAllocateSingleIds();
      this.p.id = newids[0];
      if (this.p.id <= 0) throw new Error("Cannot assign Id. Please try again");
    }
  }

  public GetEditableVersion(): SC {
    let newSC: SCProps = Utils.GetInstance().DeepCopy(this.p);
    return SC.CreateInstance(newSC, true);
  }

  public static CreateNewInstance() {
    return new SC(SCProps.Blank(), true);
  }

  public static CreateInstance(data: any, allowEdit: boolean) {
    return new SC(data as SCProps, allowEdit);
  }

  public CheckSaveValidity(_td: TransportData, vra: ValidationResultAccumulator): void {
    if (!this.AllowEdit) vra.add('', 'This object is not editable and hence cannot be saved.');
    if (!this.p.name || this.p.name.trim() == '') {
      vra.add('name', 'SC Name cannot be blank. ');
    }
    
    // Validate Month (string but numeric)
    const monthNum = Number(this.p.month);
    if (!this.p.month || isNaN(monthNum) || monthNum < 1 || monthNum > 12) {
    vra.add('month', 'Please select a valid month.');
    }
    
     // ✔ Correct validation for compulsory + > 0
  if (!this.p.sanctioned_no_of_asha_in_sc || this.p.sanctioned_no_of_asha_in_sc  <= 0) {
    vra.add('sanctioned_no_of_asha_in_sc', 'Sanctioned No. of Asha must be greater than 0.');
  }
  

  }

  public MergeIntoTransportData(td: TransportData) {
    DataContainerService.GetInstance().MergeIntoContainer(td.MainData, SC.mastertablename, this.p);
  }

  private static m_currentInstance: SC = SC.CreateNewInstance();

  public static GetCurrentInstance() {
    return SC.m_currentInstance;
  }

  public static SetCurrentInstance(value: SC) {
    SC.m_currentInstance = value;
  }

  // ********************************************
  public static cacheDataChangeLevel: number = -1;

  public static SingleInstanceFromTransportData(td: TransportData): SC {
    let dcs = DataContainerService.GetInstance();
    if (dcs.CollectionExists(td.MainData, SC.mastertablename)) {
      for (let data of dcs.GetCollection(td.MainData, SC.mastertablename)!.Entries) {
        return SC.CreateInstance(data, false);
      }
    }

    return null as any;
  }

  public static ListFromDataContainer(cont: DataContainer,
    filterPredicate: (arg0: any) => boolean = null as any,
    sortPropertyName: string = "Name"): SC[] {
    let result: SC[] = [];

    let dcs = DataContainerService.GetInstance();

    if (dcs.CollectionExists(cont, SC.mastertablename)) {
      let coll = dcs.GetCollection(cont, SC.mastertablename)!;
      let entries = coll.Entries;

      if (!isNullOrUndefined(filterPredicate)) entries = entries.filter(filterPredicate);

      if (sortPropertyName.trim().length > 0) {
        entries = Utils.OrderByPropertyName(entries, sortPropertyName);
      }

      for (let data of entries) {
        result.push(SC.CreateInstance(data, false));
      }
    }

    return result;
  }

  public static ListFromTransportData(td: TransportData): SC[] {
    return SC.ListFromDataContainer(td.MainData);
  }

  public static async FetchTransportData(req: SCFetchRequest, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdRequest = req.FormulateTransportData();
    let pktRequest = PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(tdRequest);

    let tr = await ServerCommunicatorService.GetInstance().sendHttpRequest(pktRequest);
    if (!tr.Successful) {
      if (!isNullOrUndefined(errorHandler)) await errorHandler(tr.Message);
      return null;
    }

    let tdResponse = JSON.parse(tr.Tag) as TransportData;
    return tdResponse;
  }

  public static async FetchInstance(id: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new SCFetchRequest();
    req.sc_ids.push(id);

    let tdResponse = await SC.FetchTransportData(req, errorHandler) as TransportData;
    return SC.SingleInstanceFromTransportData(tdResponse);
  }

  public static async FetchList(req: SCFetchRequest, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdResponse = await SC.FetchTransportData(req, errorHandler) as TransportData;
    return SC.ListFromTransportData(tdResponse);
  }

  public static async FetchEntireList(errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new SCFetchRequest();
    let tdResponse = await SC.FetchTransportData(req, errorHandler) as TransportData;
    return SC.ListFromTransportData(tdResponse);
  }
  public static async FetchEntireListByPHCRef(phc_id: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new SCFetchRequest();
    if(phc_id){ 
      req.phc_ids.push(phc_id)
     }
    let tdResponse = await SC.FetchTransportData(req, errorHandler) as TransportData;
    return SC.ListFromTransportData(tdResponse);
  }

    public static async FetchEntireListByPHCRefs(phc_ids: number [], errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new SCFetchRequest();
    req.phc_ids = phc_ids
    let tdResponse = await SC.FetchTransportData(req, errorHandler) as TransportData;
    return SC.ListFromTransportData(tdResponse);
  }

   public static async FetchEntireListByFilters(zone_id: number,district_id: number,block_id: number,bcm_post_ids: number, phc_id: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new SCFetchRequest();
    if(zone_id){
      req.zone_ids.push(zone_id)
    }
     if(district_id){
      req.district_ids.push(district_id)
    }
     if(block_id){
      req.block_ids.push(block_id)
    }
     if(bcm_post_ids){
      req.bcm_post_ids.push(bcm_post_ids)
    }
     if(phc_id){
      req.phc_ids.push(phc_id)
    }
    let tdResponse = await SC.FetchTransportData(req, errorHandler) as TransportData;
    return SC.ListFromTransportData(tdResponse);
  }

    public static async FetchEntireListByaf_id(af_id: number, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let req = new SCFetchRequest();
    req.af_ids.push(af_id)
    let tdResponse = await SC.FetchTransportData(req, errorHandler) as TransportData;
    return SC.ListFromTransportData(tdResponse);
  }

  public async DeleteInstance(successHandler: () => Promise<void> = null!, errorHandler: (err: string) => Promise<void> = UIUtils.GetInstance().GlobalUIErrorHandler) {
    let tdRequest = new TransportData();
    tdRequest.RequestType = RequestTypes.Deletion;

    this.MergeIntoTransportData(tdRequest);
    let pktRequest = PayloadPacketFacade.GetInstance().CreateNewPayloadPacket2(tdRequest);

    let tr = await ServerCommunicatorService.GetInstance().sendHttpRequest(pktRequest);
    if (!tr.Successful) {
      if (!isNullOrUndefined(errorHandler)) await errorHandler(tr.Message);
    }
    else {
      if (!isNullOrUndefined(successHandler)) await successHandler();
    }
  }

}
